import { carouselItems } from '@/mocks/homeData';

export default function Carousel() {
  return (
    <section id="carousel" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900">
              焦点专题
            </h2>
            <p className="text-sm text-foreground-500 mt-2">
              深度策划专题内容，换个角度吃瓜更有滋味
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 md:gap-6">
            {carouselItems.map((item) => (
              <article
                key={item.title}
                className="group relative bg-background-100 rounded-2xl overflow-hidden cursor-pointer"
              >
                <div className="relative w-full aspect-[16/9] md:aspect-[21/10] bg-background-200 overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                    onError={(e) => {
                      const target = e.currentTarget;
                      target.style.display = 'none';
                    }}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                  <span className="absolute top-4 left-4 px-3 py-1 rounded-full text-xs font-medium bg-accent-500 text-background-50 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                  <h3 className="font-heading text-lg md:text-xl text-background-50 mb-2">
                    {item.title}
                  </h3>
                  <p className="text-sm text-background-200 leading-relaxed line-clamp-2">
                    {item.desc}
                  </p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}